import { Component, ViewChild, OnInit } from "@angular/core";
import * as moment from "moment/moment";
import { ModalComponent } from "../modal/modal.component";
import { InlineResponse200, Profile } from "profile-api";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { CommonService } from "src/app/common.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  GetAnnouncementTypeDescription,
  GetAnnouncementStatusDescription,
} from "../utils/announcement-utils";
import { Announcement, AnnouncementList } from "announcement-api";
import { AnnouncementOffer, AnnouncementOfferList } from "announcement-offer-api";

@Component({
  selector: "app-showcase-announcement",
  templateUrl: "./showcase-announcement.component.html",
  styleUrls: ["./showcase-announcement.component.css"],
})
export class ShowcaseAnnouncementComponent implements OnInit {
  @ViewChild("denialModal") denialModal: ModalComponent;
  @ViewChild("unauthorizedModal") unauthorizedModal: ModalComponent;

  pageSize: number = 5;
  pageNumber: number = 0;
  loading: boolean = false;
  provinceList = null;
  categoryList = [];
  error = "no_error";
  specializationTypes = null;
  form: FormGroup;
  offerForm: FormGroup;
  announcementOffers: Array<AnnouncementOffer> = [];
  cards: Array<Announcement> = [];
  type: string = null;
  showMore: boolean = false;
  selectedAnnouncement: Announcement;
  displayOffer = "none";
  profile: Profile = {};

  constructor(
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    window["moment"] = moment;
    this.profile = JSON.parse(localStorage.getItem("PROFILE"));
    this.type = this.route.snapshot.queryParams["type"];
    this.selectedAnnouncement = {};
    this.offerForm = this.formBuilder.group(
      {
        amount: new FormControl(null, [Validators.required]),
        timeUnitAmount: new FormControl(null, [Validators.required]),
        timeUnitType: new FormControl(null, [Validators.required]),
        unitPrice: new FormControl(null, [Validators.required]),
        contactName: new FormControl("", [Validators.required]),
        contactPhone: new FormControl("", [Validators.required]),
        startDate: new FormControl("", [Validators.required]),
        endDate: new FormControl("", [Validators.required]),
        contactEmail: new FormControl("", [
          Validators.pattern(CommonService.EMAIL_REGEXP), Validators.required
        ]),
      }
    );

    this.commonService
      .getProfile()
      .then((profile: Profile) => {
        console.log("User logged in");
        this.profile = profile;
        if (!profile.registryCompleted) {
          this.unauthorizedModal.open();
        }else {
          this.search();
        }
      }).catch((error) => {
        console.log("User not logged in. Redirect to login -> " + this.route.snapshot.queryParams["type"]);
        console.log(error);

        this.router.navigate(["/login"], {
          queryParams: {
            fromAnnouncementShowcase: "yes",
            announcementType: this.route.snapshot.queryParams["type"],
          },
        });
      });
    //create form for modal
    this.form = this.formBuilder.group({
      descriptionFilter: new FormControl(null),
      provinceFilter: new FormControl(null),
      categoryFilter: new FormControl(null),
    });

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("ANNOUNCEMENT_CATEGORY")
      .subscribe(
        (data) => {
          this.categoryList = data.items;
          console.log(
            "categoryList: " +
            JSON.stringify(this.categoryList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista delle categorie.";
          console.log(error);
        }
      );

    this.commonService
      .getProvinces()
      .then((provinceList: InlineResponse200) => {
        this.provinceList = provinceList;
      })
      .catch((error) => {
        this.error = "Impossibile caricare la lista delle province.";
        console.log(error);
      });

    
    console.log("Cards Showcase");
    console.log(this.cards);
  }

  ngAfterContentInit() {
    
  }

  search() {
    if (!this.profile.registryCompleted) {
      this.unauthorizedModal.open();
      return;
    }
    this.pageNumber = 0;
    this.cards = [];

    this.loadCards(
      this.form.get("descriptionFilter").value,
      this.form.get("provinceFilter").value,
      this.form.get("categoryFilter").value
    );
   this.loadCustomerOffers();
  }

  loadCustomerOffers() {
    this.commonService.
      getAnnouncementOfferService().
      announcementOfferGet(100, 0, null, null, null, 'SUBMITTED')
      .subscribe(
        (res: AnnouncementOfferList) => {
          this.announcementOffers = res.announcements
          console.log("AnnouncementOfferList list: " + JSON.stringify(this.announcementOffers));
        },
        (error) => {
          console.error(error);
        }
      );

  }

  loadCards(description, province, category) {
    this.commonService
      .getPublicAnnouncementsService()
      .publicAnnouncementGet(
        this.pageSize,
        this.pageNumber,
        category,
        province,
        description,
        "PUBLISHED",
        this.type
      )
      .subscribe(
        (res: AnnouncementList) => {
          console.log("Showcase list: " + JSON.stringify(res));
          this.cards = this.cards.concat(res.announcements);
          this.cards.forEach(element => {
            this.setInitialImageUrl(element);
          });
          this.showMore =
            res.paging.pageNumber < res.paging.totalPages - 1;
          console.log(
            "Public company cards:" + JSON.stringify(this.cards)
          );
        },
        (error) => {
          console.error(error);
        }
      );
  }


  loadMoreCards() {
    this.pageNumber = this.pageNumber + 1;
    this.loadCards(
      this.form.get("descriptionFilter").value,
      this.form.get("provinceFilter").value,
      this.form.get("categoryFilter").value
    );
  }

  getStatusDesciption(statusCode: string) {
    return GetAnnouncementStatusDescription(statusCode);
  }

  getFormattedDate(date: string) {
    return moment(date).format("DD-MM-YYYY");
  }
 
  getAttachmentList(announcement: Announcement, type: string) {
    let imageExt = ["jpg", "jpeg", "png", "gif"];
    let imageList = announcement
      .attachments
      .filter((item) =>
        imageExt.includes(item.fileName.toLocaleLowerCase().substr(item.fileName.toLocaleLowerCase().lastIndexOf('.') + 1)));

    let attachmentList = announcement
      .attachments
      .filter((item) =>
        !imageExt.includes(item.fileName.toLocaleLowerCase().substr(item.fileName.toLocaleLowerCase().lastIndexOf('.') + 1)));

    let counter = 1;
    attachmentList.forEach(item => {
      //item.fileName = "Allegato_" + counter++ + item.fileName.toLocaleLowerCase().substr(item.fileName.toLocaleLowerCase().lastIndexOf('.'));
      item.fileName = (item.documentType?item.documentType: "Allegato_" + counter++) + item.fileName.toLocaleLowerCase().substr(item.fileName.toLocaleLowerCase().lastIndexOf('.'));
    });

    return type === 'IMAGE' ? imageList : attachmentList;
  }


  getProvincesAsString(announcement: Announcement) {
    let provincesAsString = "";
    this.provinceList.forEach(element => {
      if (announcement.provinces.includes(element.code)) {
        provincesAsString += element.description + ",";
      }
    });
    if (provincesAsString.length === 0) {
      return "Tutte le province"
    }
    return provincesAsString.slice(0, -1);
  }

  increaseCardImage(card) {
    let img = document.getElementById(card.announcementId + "_image") as HTMLImageElement;

    if (!card.currentImageIndex) {
      card.currentImageIndex = 0;
    }
    let imageList = this.getAttachmentList(card, 'IMAGE')
    card.currentImageIndex++;
    if (card.currentImageIndex > imageList.length - 1) {
      card.currentImageIndex = 0;
    }
    let imageUrl = imageList[card.currentImageIndex].documentUrl;
    console.log("card: " + imageUrl);
    card.currentImageUrl = imageUrl;
    img.src = imageUrl;

  }

  decreaseCardImage(card) {
    let img = document.getElementById(card.announcementId + "_image") as HTMLImageElement;
    if (!card.currentImageIndex) {
      card.currentImageIndex = 0;
    }
    let imageList = this.getAttachmentList(card, 'IMAGE')
    card.currentImageIndex--;
    if (card.currentImageIndex < 0) {
      card.currentImageIndex = imageList.length - 1;
    }
    let imageUrl = imageList[card.currentImageIndex].documentUrl;
    console.log("card: " + imageUrl);
    card.currentImageUrl = imageUrl;
    img.src = imageUrl;
  }

  openAttachmentUrl(attachmentUrl: string) {
    console.log("Attachment url: " + attachmentUrl);
    if (attachmentUrl) {
      window.open(attachmentUrl);
    }
  }

  setInitialImageUrl(card) {
    let imageList = this.getAttachmentList(card, 'IMAGE')
    if (imageList && imageList.length > 0) {
      card.currentImageUrl = imageList[0].documentUrl;
    }
  }

  getOffer(card: Announcement) {
    let offers = this.announcementOffers.filter((item) => item.announcementId === card.announcementId);
    if (offers.length > 0) {
      return offers[0];
    }
    return null;
  }

  onOfferSubmit() {
    this.loading = true;
    if (!this.validateOffer()) {
      this.loading = false;
      return;
    } else {
      this.error = "no_error";
    }
    
    let announcementOffer = this.getAnnouncementOffer();
    console.log('Sending announcementoffer: ' + JSON.stringify(announcementOffer));
    this.commonService
    .getAnnouncementOfferService()
    .announcementOfferPost(announcementOffer)
    .subscribe(
      (announcement: Announcement) => {
        console.log("AnnouncementOffer correctly saved");
        
        setTimeout(() => {
          this.changeModal();  
          this.loading = false;
          setTimeout(() => {
            this.cards=[];
            this.search();
          }, 500);
        }, 2000);
        
      },
      (error) => {
        if (error.status === 400) {
          this.error = error.error.errors[0].text;
        } else {
          this.error =
            "Si è verificato un errore durante il salvataggio dell'offerta.";
        }
        console.log(error);
        this.loading = false;
      }
    );
  }

  resetValidators() {
    const controls = this.form.controls;
    this.offerForm.updateValueAndValidity();
    Object.keys(controls).forEach((controlName) =>
      controls[controlName].updateValueAndValidity()
    );
    Object.keys(controls).forEach((controlName) =>
      controls[controlName].markAsDirty()
    );
  }

  validateOffer() {
    this.resetValidators();
    if (this.type === 'RENTAL') {
      if (this.offerForm.get("startDate").invalid) {
        this.error = "Selezionare la data di inizio noleggio";
        return false;
      } else {
        this.error = "";
      }

      if (this.offerForm.get("endDate").invalid) {
        this.error = "Selezionare la data di fine noleggio";
        return false;
      } else {
        this.error = "";
      }

      let startDate = moment(this.offerForm.get("startDate").value)
      let endDate = moment(this.offerForm.get("endDate").value)
      
      if (startDate > endDate) {
        this.error = "Scegliere una data di fine noleggio posteriore a quella di inizio";
        return false;
      } else {
        this.error = "no_error";
      }
    }


    if (!this.form.valid) {
      const controls = this.form.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          console.log(name + " is invalid");
          this.error = "I campi non sono compilati correttamente.";
          break;
        }
      }
      return false;
    }
    return true;
  }

  changeModal() {
    console.log("change modal: " + this.displayOffer);
    this.resetValidators();
    switch (this.displayOffer) {
      case "none":
        this.displayOffer = "block";
        break;
      case "block":
        this.displayOffer = "none";
        break;
    }
    
  }

  makeOffer(card: Announcement) {
    this.commonService.getProfile().then((profile: Profile) => {
      if (!profile.announcementEnabled) {
        this.denialModal.open();
      }else {
        console.log("Making offer");
        this.selectedAnnouncement = card;
        this.offerForm.get("contactEmail").setValue(this.profile.email);
        this.offerForm.get("contactName").setValue(this.profile.firstName + ' ' + this.profile.lastName);
        this.offerForm.get("contactPhone").setValue(this.profile.phone);
        this.offerForm.get("amount").setValue(1);
        this.offerForm.get("timeUnitAmount").setValue(1);
        this.offerForm.get("timeUnitType").setValue('giorni');
        this.offerForm.get("unitPrice").setValue(this.selectedAnnouncement.unitPrice);
        this.changeModal();
      }
    });
   
  }

  getAnnouncementOffer() {
    let formValues = this.offerForm.getRawValue();
    delete formValues.startDate;
    delete formValues.endDate;
    let startDate = moment(this.offerForm.get("startDate").value);
    let endDate = moment(this.offerForm.get("endDate").value);
    let announcementOffer: AnnouncementOffer = 
    {
      ...formValues, 
      announcementId: this.selectedAnnouncement.announcementId,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
    };
    console.log("type: " + this.type);
    if (this.type === 'SALE') {
      delete announcementOffer.startDate;
      delete announcementOffer.endDate;
    }
    return announcementOffer;
  }

  unauthorizedModalSubmit() {
    this.router.navigate(['/areariservata'], { queryParams: { tabToLoad: 'profile', fromRestrictedArea: true, returnResource:  'annunci?type=' + this.type} });
    this.unauthorizedModal.close();
  }
}
